import { PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { PopularFeaturesMap } from '../constants/PopularFeaturesMap';
export const getFeaturesByProductLine = ({
  features
}, {
  productLine
}) => {
  if (!features || !Object.keys(features).length) return [];
  return features.features[productLine] || [];
};
export const getAllFeaturesByAllProductLines = ({
  features
}) => {
  if (!features || !Object.keys(features).length) return {};
  return features.features;
};
const areEqual = (array1, array2) => {
  if (array1.length === array2.length) {
    return array1.every(element => {
      if (array2.includes(element)) {
        return true;
      }
      return false;
    });
  }
  return false;
};
export const hasFeaturesForProductLineAndHighlights = ({
  features
}, {
  productLine,
  highlightedProducts
}) => {
  const productsInState = features && features.highlightedProducts && features.highlightedProducts[productLine] || [];
  if (!features || !productsInState.length) {
    return false;
  }
  return areEqual(highlightedProducts, productsInState);
};
export const getFeatureWithDefaults = ({
  features
}, {
  shortName
}) => {
  if (!features || !Object.keys(features).length) return null;
  return features.defaults[shortName] || null;
};
export const getPopularFeaturesByProductLine = ({
  features
}, {
  productLine,
  upgradePointApiName,
  upgradePointFeature,
  productLevel
}) => {
  if (!upgradePointFeature || !features || !Object.keys(features).length || productLevel !== PROFESSIONAL) return [];
  const featuresByProductLine = features.features[productLine] || [];
  const popularFeatures = PopularFeaturesMap[upgradePointApiName];
  // Remove the current upgrade page feature from the popular features list
  const popularFeatureKeys = Object.keys(popularFeatures);
  const currentFeatureKey = Object.keys(popularFeatures).find(key => popularFeatures[key].includes(upgradePointFeature));
  if (currentFeatureKey !== undefined) delete popularFeatures[currentFeatureKey];
  // Sort by popularity (ordered defined in PopularFeaturesMap) and return only the top 3
  return featuresByProductLine.filter(feature => feature.shortName in popularFeatures).sort((a, b) => popularFeatureKeys.indexOf(a.shortName) - popularFeatureKeys.indexOf(b.shortName)).slice(0, 3);
};